import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createI18n } from 'vue-i18n'
import 'leaflet/dist/leaflet.css';

import en from '@/assets/locales/en.json'
import kz from '@/assets/locales/kz.json'
import ru from '@/assets/locales/ru.json'

// Локаль сохраняется в localStorage — выбирается один раз на стартовой странице.
// По ТЗ 03.09.2026: основной язык интерфейса — казахский (>90% книг службы
// ведётся на казахском). Русский доступен переключателем в шапке.
export const SUPPORTED_LOCALES = ['kz', 'ru']
export const DEFAULT_LOCALE = 'kz'

function readSavedLocale() {
  try {
    const saved = localStorage.getItem('locale')
    if (saved && SUPPORTED_LOCALES.includes(saved)) return saved
  } catch {}
  return DEFAULT_LOCALE
}

const i18n = createI18n({
  legacy: false, // включаем Composition API для useI18n()
  globalInjection: true,
  locale: readSavedLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: { en, kz, ru },
})

/** Смена активной локали, синхронизуется с localStorage и <html lang>. */
export function setLocale(locale) {
  if (!SUPPORTED_LOCALES.includes(locale)) return
  i18n.global.locale.value = locale
  try { localStorage.setItem('locale', locale) } catch {}
  try { document.documentElement.setAttribute('lang', locale) } catch {}
}

// Инициализация языка HTML для корректной работы браузерных читалок.
try { document.documentElement.setAttribute('lang', i18n.global.locale.value) } catch {}

const app = createApp(App)
app.use(router)
app.use(i18n)
app.mount('#app')

// Прелоад тяжёлой карты-подложки сразу после старта — чтобы при первом
// открытии /kps/map или /map-scheme она уже была в кэше браузера.
import('./assets/mapPreload').then(m => m.preloadKnownMaps()).catch(() => {})